import { useMemo } from "react";
 import { useSettings } from "../queries";
import { useApiAccess } from "@repo/hooks/contexts";

export const useBlobUrl = (fileName?: string) => {
  const { storageContainerSas } = useApiAccess();
  const { data: coreSettings } = useSettings();

  return useMemo(() => {
    if (!storageContainerSas || !fileName || !coreSettings) return "";

    const baseUrl = import.meta.env.VITE_FILES_URL;
    const cleanFileName = fileName.replace(/^\/+/, "");

    let folderPath =
      coreSettings.AzureStorageContainerName +
      "/" +
      coreSettings.AzureStorageFolderName;

    if (coreSettings.AzureStorageTenantFolderName) {
      folderPath += "/" + coreSettings.AzureStorageTenantFolderName;
    }

    return `${baseUrl}/${folderPath}/${cleanFileName}?${storageContainerSas}`;
  }, [storageContainerSas, fileName, coreSettings]);
};

